import * as React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Card, Stack, Typography, Grid } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  UploadQuestionCard,
  CreateQuestionCard,
} from "../../../shared-components/workflows/AddQuestions";
import { QuestionExtractionProgress } from "../components/QuestionExtractionProgress";
import { withPageTracking } from "../../../services/postHog";

const QuestionCreate = () => {
  const navigate = useNavigate();
  const [createdQuestion, setCreatedQuestion] = useState(null);
  const [extracting, setExtracting] = useState(false);
  const [extractionStatus, setExtractionStatus] = useState({});

  const onExtractionUpdate = (extractedQuestions, status) => {
    if (status) setExtractionStatus(status);
    if (Array.isArray(extractedQuestions) && extractedQuestions.length > 0) {
      setCreatedQuestion(extractedQuestions[0]);
    }
  };

  return (
    <FruitifyContainer>
      <Card mb={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h3" fontWeight="bold">
            Create Question
          </Typography>
        </Stack>
      </Card>

      <Grid container spacing={2} sx={{ width: "100%", mt: 1, mb: 2 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <UploadQuestionCard
            details={null}
            setExtracting={setExtracting}
            onExtractionUpdate={onExtractionUpdate}
            singleQuestion={true}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CreateQuestionCard
            details={{
              subject: null,
              educationLevel: null,
              yearGroup: null,
            }}
            existingQuestion={createdQuestion}
            setExistingQuestion={setCreatedQuestion}
            onComplete={(q) => navigate(`/questions/view/${q.id}`)}
          />
        </Grid>
      </Grid>
      {extracting && <QuestionExtractionProgress job={extractionStatus} />}
    </FruitifyContainer>
  );
};

export default withPageTracking(QuestionCreate, { feature: "question-create" });
